import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InvoicingRoutingModule } from './invoicing.routing';

@NgModule({
  declarations: [],
  imports: [CommonModule, InvoicingRoutingModule]
})
export class InvoicingModule {}
